import React from 'react';
import { Helmet } from 'react-helmet-async';

const AboutPage = () => {
  const siteUrl = 'https://www.marketingcalculatorhub.com';
  const pageUrl = `${siteUrl}/about`;
  const logoUrl = `${siteUrl}/logo.png`;

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>About Marketing Calculator Hub: Your Data-Driven Marketing Partner</title>
        <meta name="description" content="Discover Marketing Calculator Hub - your comprehensive resource for marketing calculators and tools. Empower your marketing strategies with data-driven insights." />
        <meta name="keywords" content="marketing calculators, marketing tools, data-driven marketing, marketing analytics, marketing strategy" />
        <link rel="canonical" href={pageUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content="About Marketing Calculator Hub: Your Data-Driven Marketing Partner" />
        <meta property="og:description" content="Discover Marketing Calculator Hub - your comprehensive resource for marketing calculators and tools. Empower your marketing strategies with data-driven insights." />
        <meta property="og:image" content={logoUrl} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={pageUrl} />
        <meta property="twitter:title" content="About Marketing Calculator Hub: Your Data-Driven Marketing Partner" />
        <meta property="twitter:description" content="Discover Marketing Calculator Hub - your comprehensive resource for marketing calculators and tools. Empower your marketing strategies with data-driven insights." />
        <meta property="twitter:image" content={logoUrl} />

        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Marketing Calculator Hub",
            "description": "Comprehensive suite of marketing calculators and tools for data-driven marketing strategies",
            "url": siteUrl,
            "logo": logoUrl,
            "sameAs": [
              "https://www.facebook.com/marketingcalculatorhub",
              "https://www.twitter.com/mktgcalchub",
              "https://www.linkedin.com/company/marketing-calculator-hub"
            ]
          })}
        </script>
      </Helmet>
      <h1 className="text-3xl font-bold text-gray-800 mb-6">About Marketing Calculator Hub</h1>
      <p className="text-gray-600 mb-4">
        Marketing Calculator Hub is your go-to resource for a comprehensive suite of marketing calculators and tools. Our mission is to empower marketers, business owners, and professionals with the data-driven insights they need to make informed decisions and optimize their marketing strategies.
      </p>
      <p className="text-gray-600 mb-4">
        We offer a wide range of calculators covering various aspects of marketing, including:
      </p>
      <ul className="list-disc list-inside text-gray-600 mb-4">
        <li>ROI and Performance Metrics</li>
        <li>Customer Acquisition and Retention</li>
        <li>Social Media and Content Marketing</li>
        <li>Email Marketing</li>
        <li>Advertising and Media Planning</li>
        <li>And much more!</li>
      </ul>
      <p className="text-gray-600 mb-4">
        Our tools are designed to be user-friendly, accurate, and up-to-date with the latest marketing trends and best practices. Whether you're a seasoned marketing professional or just starting out, our calculators can help you measure, analyze, and improve your marketing efforts.
      </p>
      <p className="text-gray-600 mb-4">
        We're committed to continually expanding our offerings and improving our existing tools to meet the evolving needs of the marketing community. If you have any suggestions for new calculators or improvements to our existing ones, we'd love to hear from you!
      </p>
      <p className="text-gray-600">
        Thank you for choosing Marketing Calculator Hub as your marketing analytics partner. We're here to help you achieve your marketing goals and drive success for your business.
      </p>
    </div>
  );
};

export default AboutPage;
